module.exports = __webpack_public_path__ + "img/sign-overly-success.5b329694.png";